import {
  RtbCampaignBasicFormModel,
  RtbCampaignBasicFormModelConstructorParams
} from './RtbCampaignBasicFormModel';
import { AdType } from 'core/rtbCampaign/RtbCampaign';
import { AbstractOutdoorCampaignFormModel } from './OutdoorCampaignFormModel';
import { LimitationData } from 'core/limitation/Limitation';
import {
  LIMITATION_TYPE,
  LimitationInventorySettings
} from 'containers/Limitations/LimitationSetting/limitationConfig/limitationSettingsType';
import { getRtbOutdoorLimitationInventorySettings } from 'containers/Limitations/LimitationSetting/limitationConfig/outdoorLimitationInventorySettings';
import { OPERATE } from 'enum/Operate';
import { defaultItemSetting } from 'components/CampaignLimitation/SelectItemComponent';
import { SelectComponent } from 'components/CampaignLimitation/SelectComponent';
import { PublisherCustomInputComponentModel } from 'components/CampaignLimitation';

export interface SandboxOutdoorFormModel extends RtbCampaignBasicFormModel {
  readonly canEditBudgetPlan: boolean;
  readonly canEditPriceModel: boolean;
}

abstract class AbstractSandboxOutdoorFormModel
  extends AbstractOutdoorCampaignFormModel
  implements SandboxOutdoorFormModel
{
  override get campaignAdType(): AdType {
    return AdType.SANDBOX_OUTDOOR;
  }

  override getDefaultLimitations(): LimitationData {
    return {
      include: [],
      exclude: [],
      preferred: [],
      nonPreferred: [],
      other: [
        {
          op: 'inc',
          type: 'dealId',
          value: [{ label: 'demo_space', value: 'demo_space' }]
        }
      ]
    };
  }

  override getLimitationInventorySetting(requiredOperateOfTaTypes: {
    [key: string]: string[];
  }): LimitationInventorySettings[] {
    const originLimitationInventorySettings =
      getRtbOutdoorLimitationInventorySettings(
        requiredOperateOfTaTypes,
        LIMITATION_TYPE.CAMPAIGN,
        this.l1Object.channelGroupId,
        this.campaignAdType,
        this.l1Object.channel
      );
    return [
      ...originLimitationInventorySettings,
      {
        name: 'publisher',
        title: 'limitation.labels.publisher',
        singleSelect: false,
        ignoreValidateOption: true,
        supportOperates: [OPERATE.INCLUDE, OPERATE.EXCLUDE],
        itemSetting: defaultItemSetting(),
        searchPlaceholder: '',
        ignoreAddonFeature: true,
        component: SelectComponent,
        customInputModelGetter: () => new PublisherCustomInputComponentModel(),
        cb: async () => []
      }
    ];
  }
}

export class EditSandboxOutdoorFormModel extends AbstractSandboxOutdoorFormModel {
  constructor(...args: RtbCampaignBasicFormModelConstructorParams) {
    super('edit', ...args);
  }
  get canEditBudgetPlan(): boolean {
    return false;
  }
  get canEditPriceModel(): boolean {
    return false;
  }
  canEditOptimize(): boolean {
    return false;
  }
}

export class CreateSandboxOutdoorFormModel extends AbstractSandboxOutdoorFormModel {
  constructor(...args: RtbCampaignBasicFormModelConstructorParams) {
    super('create', ...args);
  }
  get canEditBudgetPlan(): boolean {
    return true;
  }
  get canEditPriceModel(): boolean {
    return true;
  }
}
